import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  loading: false,
  meetingReportLoading: false,
  meetingReport: "",
  error: "",
  meeting: [],
  meetings: [],
  meetingRegisteries: [],
  registeryPagination: {},
});

export default function meetingReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_MEETING.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.FETCH_MEETING.SUCCESS: {
      return state
        .set("error", "")
        .set("meeting", action.data)
        .set("loading", false);
    }
    case ACTIONS.FETCH_MEETING.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    //  CREATE
    case ACTIONS.CREATE_MEETING.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.CREATE_MEETING.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetings", action.data);
    }
    case ACTIONS.CREATE_MEETING.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    // UPDATE
    case ACTIONS.UPDATE_MEETING.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.UPDATE_MEETING.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetings", action.data);
    }
    case ACTIONS.UPDATE_MEETING.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.MEETINGS.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.MEETINGS.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetings", action.data);
    }
    case ACTIONS.MEETINGS.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.CANCEL_MEETING.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.CANCEL_MEETING.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetings", action.data);
    }
    case ACTIONS.CANCEL_MEETING.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    // DELETE
    case ACTIONS.DELETE_MEETING.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.DELETE_MEETING.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetings", action.data);
    }
    case ACTIONS.DELETE_MEETING.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.MEETING_REGISTERY.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.MEETING_REGISTERY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetingRegisteries", action.data);
    }
    case ACTIONS.MEETING_REGISTERY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.SORT_MEETING_REGISTERY.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.SORT_MEETING_REGISTERY.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("meetingRegisteries", action.data);
    }
    case ACTIONS.SORT_MEETING_REGISTERY.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    case ACTIONS.MEETING_REGISTERY_PDF.PENDING: {
      return state
        .set("error", "")
        .set("meetingReportLoading", true)
        .set("meetingReport", "");
    }
    case ACTIONS.MEETING_REGISTERY_PDF.SUCCESS: {
      return state
        .set("meetingReportLoading", false)
        .set("error", "")
        .set("meetingReport", action.data);
    }
    case ACTIONS.MEETING_REGISTERY_PDF.ERROR: {
      return state
        .set("meetingReportLoading", false)
        .set("error", action.error);
    }

    case ACTIONS.CLEAR_MEETING_REGISTERY: {
      return state.set("meetingReport", "");
    }

    default: {
      return state;
    }
  }
}
